import { getFilteredEmployees } from "./services/dimension-service";

export const overrideEndpoints = [
    {
        'overrideValue': 'adUserData',
        'serviceCall': getFilteredEmployees,
    }
]